// 表单重置
export function resetForm(refName) {
    console.log(refName)
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}